<div class="modal-header">
  <h4 class="modal-title">{{ 'user branches'|translate }}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="userForm" (ngSubmit)="onFormSubmit()" id="ngForm">

    <div class="row">
        <div class="col-md-12">
            <label class="form-label">{{ 'branch'|translate }} <span class="text-danger">*</span></label>
            <ng-select
                    [items]="branches"
                    bindLabel="name"
                    bindValue="id"
                    [multiple]="true"
                    placeholder="{{ 'choose a branch'|translate }}"
                    formControlName="userBranches"
                    [ngClass]="{'is-invalid': fc['userBranches'].invalid && isSubmitted}"
                    [(ngModel)]="branchSelected">
            </ng-select>
            <div class="invalid-feedback" *ngIf="fc['userBranches'].errors?.['required']">{{ 'this field is required'|translate }}</div>
            <div class="invalid-feedback" *ngIf="fc['userBranches'].errors?.['serverError']">
                {{ fc['userBranches'].errors?.['serverError'] }}
            </div>
        </div>
    </div>

  </form>
</div>
<div class="modal-footer">

  <button form="ngForm" (submit)="onFormSubmit()" style="margin-right: 10px;" type="submit" class="btn btn-sm btn-primary m-r-10">
    <i class="fa fa-save" *ngIf="!saving; else isSaving" style="margin-right: 5px;"></i>
    <ng-template #isSaving>
      <i class="fa fa-spin fa-spinner me-2"></i>
    </ng-template>
    {{ 'save'|translate }}
  </button>
    <button  type="button" class="btn btn-sm btn-outline-dark" (click)="activeModal.close('Close click')">
        <i class="icofont icofont-ui-close" style="margin-right: 2px;"></i>
        {{ 'close'|translate }}
    </button>


</div>